export default {
  fg: "#0e101c",
  bg: "#fff",
  accent: "#697784",
  alt: "#34414C"
}
